export const SITE_URL = 'https://ariesspring.dev'
export const CONTACT_EMAIL = 'hi@ariesspring.dev'

export const MCP_SERVER_INFO = { name: 'ariesspring-portfolio', version: '1.0.0' }

export function estimateTokens(text: string) {
  return Math.ceil(text.length / 4)
}

export const LLMS_TXT = `# Aries Spring — Creative Developer & Designer

Aries Spring is a creative developer and designer specializing in immersive 3D web experiences, interactive designs, and digital craftsmanship. This site showcases their portfolio, skills, project case studies, and a fully interactive developer terminal.

## Core Navigation & Sections

- **Home / Main Experience** (${SITE_URL})
  - The primary landing experience built with GSAP scroll triggers, smooth scroll (Lenis), and custom React layouts.
- **Craft / Capabilities** (${SITE_URL}/#craft)
  - Features an interactive 3D WebGL Rune model built using React Three Fiber (R3F) and post-processing bloom effects.
  - Represents creative engineering skills (WebGL, shaders, three.js, performance optimization).
- **Proof / Real-Time Metrics** (${SITE_URL}/#proof)
  - Displays interactive proof-of-work cards and real-time developer metrics (FPS, network speed, browser characteristics).
- **Work / Case Studies** (${SITE_URL}/#work)
  - Showcases commercial and personal projects including Solvage, Lunary, Lilypad, DistrictP, DevForms, and Koru.
- **Terminal** (${SITE_URL}/#terminal)
  - A mock Unix-style command-line terminal environment allowing users to query about, projects, skills, contact info, and execute custom interactive commands.
- **Echo / Quote Concierge** (${SITE_URL}/#quote)
  - An interactive step-by-step questionnaire system for booking developer services and estimating project budgets.
- **Contact** (${SITE_URL}/#contact)
  - Direct developer contact details, social links, and email forms. Email: ${CONTACT_EMAIL}

## Technical Stack & Characteristics

- **Framework**: Next.js (App Router, Turbopack, SSR/Static Generation)
- **Styling**: Tailwind CSS & Vanilla CSS
- **3D Graphics**: Three.js, React Three Fiber, GLSL shaders, ACES Filmic tone mapping
- **Animations**: GSAP, React Spring, Lenis Smooth Scroll
- **Interactivity**: Socket.io real-time syncing, full keyboard navigation, accessible dialog panels

## AI Agent Integration

This site is agent-ready. Discovery resources for AI agents and search bots:

- **Markdown Negotiation**: Request \`/\` with header \`Accept: text/markdown\` to receive this Markdown summary directly.
- **MCP Server**: Streamable HTTP endpoint at ${SITE_URL}/api/mcp (tools for projects, stats, and contact). Server card: ${SITE_URL}/.well-known/mcp/server-card.json
- **API Catalog (RFC 9727)**: ${SITE_URL}/.well-known/api-catalog — OpenAPI spec at ${SITE_URL}/api/openapi.json, health at ${SITE_URL}/api/status
- **Agent Skills**: ${SITE_URL}/.well-known/agent-skills/index.json
- **Authentication Guidance**: ${SITE_URL}/auth.md — browsing is public; optional agent registration at ${SITE_URL}/api/agent/register
- **OAuth Discovery**: ${SITE_URL}/.well-known/oauth-authorization-server and ${SITE_URL}/.well-known/oauth-protected-resource
- **Crawl Discovery**: ${SITE_URL}/robots.txt and ${SITE_URL}/sitemap.xml
`
